import { render } from "./UsersListDeleteModal.vue?vue&type=template&id=eb1530f8"
import script from "./UsersListDeleteModal.vue?vue&type=script&lang=js"
export * from "./UsersListDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__